import * as React from 'react';
import { getChannelCareFlags, isFlagOn } from '@telstra-connect/channel-care/feature-flags';
import { ApplicationName } from '@telstra-connect/channel-care/activity-tracking';
import { secureRouteBuilder } from '../secure-route';
import Routes from './route-constants';
import { IApplicationDefinition, IAppRegistry } from '@apps-config';
import { RoutesHelper } from '@apps-config/routing/routing';
import { Activity } from '@utils/activity-tracking';
import ViewCases from './pages/view-cases/index-lazy'
import UnifiedTrackView from './pages/unified-track-view'
import EnquiryForm from './pages/enquiry-form/index-lazy'
import ViewDetailsCase from './pages/details-cases/index-lazy'
import DetailedCategorySelect from './pages/select-detailed-category/index-lazy';
import DetailedEnquiryForm from './pages/detailed-enquiry-form/index-lazy';
import { ApplicationsFlags } from '@telstra-connect/channel-care/state/subscription-state';
const routes = new RoutesHelper({
    rootPath: secureRouteBuilder(`${Routes.ChannelCare}/${Routes.CasesList}`),
    subpagesPathMask: secureRouteBuilder(Routes.ChannelCare)
});

declare const window: {
    applications: ApplicationsFlags
}
const applicationName = ApplicationName;
export const tracker = Activity.createTracker(applicationName);
export const customerApplications = [];
export const chanelCareRoute = routes.getPageSubpath(Routes.CasesList);
export const chanelCareSubmitEnquireRoute = routes.getPageSubpath(Routes.SubmitEnquiry);
export const chanelCareSubmitEnquirFormeRoute = routes.getPageSubpath(Routes.SubmitEnquiryForm);
export const chanelCareSubmitIntEnquireRoute = routes.getPageSubpath(Routes.SubmitIntEnquiry);
export const chanelCareBillingIntEnquiry = '/app/' + Routes.BillingEnquiryIntList;
export const channelCareUnifiedTrackingRedirect = '/app/' + Routes.OrderTrackerUnifiedTrackingEnquiries;
export const channelCareUnifiedDashboardRedirect = '/app/' + Routes.OrderTrackerUnifiedDashboard;
export const getDashboardFlags  = () => (window.applications && window.applications.Platform);
// FIXME: change this to props instead of direct import
export const chanelcareHomeRoute = routes.getPageSubpath(Routes.CasesList);
export const Application: IApplicationDefinition = {
    get applicationName() {
        return applicationName;
    },

    get acceptsUserFeedback() {
        return true;
    },

    get acceptsErrorReports() {
        return true;
    },

    get card() {
        return null;
    },

    get unifiedTrackView() {
        return UnifiedTrackView;
    },

    get tracker() {
        return tracker;
    },

    get routes() {
        return routes;
    },

    init(registry: IAppRegistry, availableToUser: boolean) {
        // FIXME: window['applications'] is used as global object need to pass this a param
        // pass this a to MFE's and other subapplications platform
        // tslint:disable-next-line: no-string-literal
        const servicesConfig = window.applications;
        // application as feature CIDN level from platform
        if (servicesConfig) {
            availableToUser = servicesConfig.Platform.channelCareDirect;
        }
        customerApplications.push(registry.applications);
        const flags = window.applications && window.applications['Channel Care'];
        if (availableToUser && flags && flags.application) {
            registry.add(Application);
        }
    },

    render() {
        const servicesConfig = window.applications;
        const flags = window.applications && window.applications['Channel Care'];
        const pathComponentMapping = flags.application && servicesConfig.Platform.channelCareDirect ? [
            {
                path: routes.getPageSubpath(Routes.SubmitEnquiry),
                component: DetailedCategorySelect
            },
            {
                path: routes.getPageSubpath(Routes.SubmitDetailedEnquiry),
                component: DetailedEnquiryForm
            },
            {
                path: routes.getPageSubpath(Routes.SubmitEnquiryForm),
                component: EnquiryForm
            },
            {
                path: routes.getPageSubpath(Routes.CaseDetailV6),
                component: ViewDetailsCase
            },
            {
                path: routes.getPageSubpath(Routes.CasesList),
                component: ViewCases
            },
        ] : [];
        return pathComponentMapping;
    },
    // disable customer care menu as main application
    menuItem(state, navigate) {
        let appPath;
        let intialPagePath;
        const ChannelCareDirect = isFlagOn(getDashboardFlags().channelCareDirect);
        const SiteMenuFeatureFlag = isFlagOn(getDashboardFlags().sideMenu);
        if (ChannelCareDirect && !SiteMenuFeatureFlag) {
            appPath = routes.getPageSubpath(Routes.CasesList);
            intialPagePath = routes.getPageSubpath(Routes.CasesList);
            return [{
                testID: 'ui-menu-get-help',
                name: 'Need help',
                icon: 'help',
                appPath,
                intialPagePath
            }];
        }
        if (state) {
            const stateUser = 'user'
            const stateOauth = 'oauth'
            const stateProfile = 'profile'
            const stateDefaultCompanyId = 'defaultCompanyId'
            const cidn = state && state[stateUser] && state[stateUser][stateOauth]
                && state[stateUser][stateOauth][stateProfile]
                && state[stateUser][stateOauth][stateProfile][stateDefaultCompanyId]
            if (cidn && (cidn.length >= 5 && cidn.length <= 8)) {
                if (!getChannelCareFlags().CCDIntEnquiry) {
                    return null;
                }
            }
        }
        return [
            {
                testID: 'ui-menu-get-help',
                name: 'Submit',
                intialPagePath: routes.getInitialPagePath(),
                appPath: routes.getAppPath(),
                onClick: () => {
                    Application.tracker.trackMenu('Submit');
                },
                subMenus: [
                    {
                        name: 'Support enquiry',
                        active: false,
                        icon: '',
                        onClick: () => {
                            Application.tracker.trackMenu('Submit:Support enquiry');
                            return (
                                navigate(chanelCareSubmitEnquireRoute)
                            )
                        }
                    },
                ],
            },
            {
                testID: 'ui-menu-get-help',
                name: 'Track',
                intialPagePath: routes.getInitialPagePath(),
                appPath: routes.getAppPath(),
                onClick: () => {
                    Application.tracker.trackMenu('Track');
                },
                subMenus: [
                    {
                        name: 'Support enquiries',
                        active: false,
                        icon: '',
                        onClick: () => {
                            Application.tracker.trackMenu('Track:Support enquiries');
                            return (
                                navigate(chanelCareRoute)
                            )
                        }
                    },
                ],
            }
        ]
    }
};

export { Routes };
